<template>
    <AdminLayout>
        <template #header>
            <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
        </template>
        <template #default>
            <div class="mt-10 space-y-6">
                <!-- Header -->
                <div class="flex items-center justify-between">
                    <div>
                        <h1 class="text-2xl font-bold text-gray-900">Edit Pengumuman</h1>
                        <p class="mt-1 text-sm text-gray-600">
                            Edit pengumuman "{{ pengumuman.judul }}"
                        </p>
                    </div>
                    <Link :href="route('pengumuman.index')"
                        class="inline-flex items-center px-4 py-2 text-xs font-semibold tracking-widest text-gray-700 uppercase transition duration-150 ease-in-out bg-gray-300 border border-transparent rounded-md hover:bg-gray-400">
                    <i class="mr-2 fas fa-arrow-left"></i>
                    Kembali
                    </Link>
                </div>

                <!-- Form -->
                <div class="bg-white rounded-lg shadow-lg">
                    <form @submit.prevent="submit" class="p-6 space-y-6">
                        <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
                            <!-- Judul -->
                            <div>
                                <label for="judul" class="block mb-2 text-sm font-medium text-gray-700">
                                    Judul Pengumuman <span class="text-red-500">*</span>
                                </label>
                                <input type="text" id="judul" v-model="form.judul"
                                    placeholder="Masukkan judul pengumuman" :class="[
                                        'block w-full rounded-md shadow-sm sm:text-sm',
                                        errors.judul
                                            ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                            : 'border-gray-300 focus:border-yellow-500 focus:ring-yellow-500'
                                    ]" required>
                                <p v-if="errors.judul" class="mt-1 text-sm text-red-600">
                                    {{ errors.judul }}
                                </p>
                            </div>

                            <!-- Prioritas -->
                            <div>
                                <label for="prioritas" class="block mb-2 text-sm font-medium text-gray-700">
                                    Prioritas <span class="text-red-500">*</span>
                                </label>
                                <select id="prioritas" v-model="form.prioritas" :class="[
                                    'block w-full rounded-md shadow-sm sm:text-sm',
                                    errors.prioritas
                                        ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                        : 'border-gray-300 focus:border-yellow-500 focus:ring-yellow-500'
                                ]" required>
                                    <option value="">Pilih Prioritas</option>
                                    <option value="rendah">Rendah</option>
                                    <option value="sedang">Sedang</option>
                                    <option value="tinggi">Tinggi</option>
                                    <option value="urgent">Urgent</option>
                                </select>
                                <p v-if="errors.prioritas" class="mt-1 text-sm text-red-600">
                                    {{ errors.prioritas }}
                                </p>
                            </div>

                            <!-- Status -->
                            <div>
                                <label for="status" class="block mb-2 text-sm font-medium text-gray-700">
                                    Status <span class="text-red-500">*</span>
                                </label>
                                <select id="status" v-model="form.status" :class="[
                                    'block w-full rounded-md shadow-sm sm:text-sm',
                                    errors.status
                                        ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                        : 'border-gray-300 focus:border-yellow-500 focus:ring-yellow-500'
                                ]" required>
                                    <option value="">Pilih Status</option>
                                    <option value="draft">Draft</option>
                                    <option value="aktif">Aktif</option>
                                    <option value="nonaktif">Non Aktif</option>
                                </select>
                                <p v-if="errors.status" class="mt-1 text-sm text-red-600">
                                    {{ errors.status }}
                                </p>
                            </div>

                            <!-- Penerbit -->
                            <div>
                                <label for="penerbit" class="block mb-2 text-sm font-medium text-gray-700">
                                    Penerbit <span class="text-red-500">*</span>
                                </label>
                                <input type="text" id="penerbit" v-model="form.penerbit"
                                    placeholder="Masukkan nama penerbit" :class="[
                                        'block w-full rounded-md shadow-sm sm:text-sm',
                                        errors.penerbit
                                            ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                            : 'border-gray-300 focus:border-yellow-500 focus:ring-yellow-500'
                                    ]" required>
                                <p v-if="errors.penerbit" class="mt-1 text-sm text-red-600">
                                    {{ errors.penerbit }}
                                </p>
                            </div>

                            <!-- Tanggal Publikasi -->
                            <div>
                                <label for="tanggal_publikasi" class="block mb-2 text-sm font-medium text-gray-700">
                                    Tanggal Publikasi <span class="text-red-500">*</span>
                                </label>
                                <input type="date" id="tanggal_publikasi" v-model="form.tanggal_publikasi" :class="[
                                    'block w-full rounded-md shadow-sm sm:text-sm',
                                    errors.tanggal_publikasi
                                        ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                        : 'border-gray-300 focus:border-yellow-500 focus:ring-yellow-500'
                                ]" required>
                                <p v-if="errors.tanggal_publikasi" class="mt-1 text-sm text-red-600">
                                    {{ errors.tanggal_publikasi }}
                                </p>
                            </div>

                            <!-- Tanggal Berakhir -->
                            <div>
                                <label for="tanggal_berakhir" class="block mb-2 text-sm font-medium text-gray-700">
                                    Tanggal Berakhir
                                </label>
                                <input type="date" id="tanggal_berakhir" v-model="form.tanggal_berakhir" :class="[
                                    'block w-full rounded-md shadow-sm sm:text-sm',
                                    errors.tanggal_berakhir
                                        ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                        : 'border-gray-300 focus:border-yellow-500 focus:ring-yellow-500'
                                ]">
                                <p v-if="errors.tanggal_berakhir" class="mt-1 text-sm text-red-600">
                                    {{ errors.tanggal_berakhir }}
                                </p>
                                <p class="mt-1 text-xs text-gray-500">
                                    Kosongkan jika tidak ada batas waktu
                                </p>
                            </div>
                        </div>

                        <!-- Konten -->
                        <div>
                            <label for="konten" class="block mb-2 text-sm font-medium text-gray-700">
                                Konten Pengumuman <span class="text-red-500">*</span>
                            </label>
                            <textarea id="konten" v-model="form.konten" rows="6"
                                placeholder="Masukkan konten pengumuman..." :class="[
                                    'block w-full rounded-md shadow-sm sm:text-sm',
                                    errors.konten
                                        ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
                                        : 'border-gray-300 focus:border-yellow-500 focus:ring-yellow-500'
                                ]" required></textarea>
                            <p v-if="errors.konten" class="mt-1 text-sm text-red-600">
                                {{ errors.konten }}
                            </p>
                        </div>

                        <!-- File Lampiran -->
                        <div>
                            <label for="file_lampiran" class="block mb-2 text-sm font-medium text-gray-700">
                                File Lampiran
                            </label>

                            <!-- Current File Display -->
                            <div v-if="pengumuman.file_lampiran"
                                class="p-3 mb-3 border border-gray-200 rounded-md bg-gray-50">
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <i class="mr-2 text-gray-500 fas fa-paperclip"></i>
                                        <span class="text-sm text-gray-700">{{ getFileName(pengumuman.file_lampiran)
                                            }}</span>
                                    </div>
                                    <div class="flex items-center space-x-2">
                                        <a :href="getFileUrl(pengumuman.file_lampiran)" target="_blank"
                                            class="text-xs text-blue-600 hover:text-blue-800">
                                            <i class="mr-1 fas fa-download"></i>
                                            Unduh
                                        </a>
                                        <button type="button" @click="removeCurrentFile"
                                            class="text-xs text-red-600 hover:text-red-800">
                                            <i class="mr-1 fas fa-trash"></i>
                                            Hapus
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <input type="file" id="file_lampiran" @change="handleFileUpload"
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif" :class="[
                                    'block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-yellow-50 file:text-yellow-700 hover:file:bg-yellow-100',
                                    errors.file_lampiran ? 'border-red-300' : 'border-gray-300'
                                ]">
                            <p v-if="errors.file_lampiran" class="mt-1 text-sm text-red-600">
                                {{ errors.file_lampiran }}
                            </p>
                            <p class="mt-1 text-xs text-gray-500">
                                Format yang didukung: PDF, DOC, DOCX, JPG, JPEG, PNG, GIF (Maks. 10MB)
                                <br>Pilih file baru untuk mengganti file yang ada
                            </p>
                        </div>

                        <!-- Form Actions -->
                        <div class="flex items-center justify-end pt-6 space-x-4 border-t border-gray-200">
                            <Link :href="route('pengumuman.index')"
                                class="inline-flex items-center px-4 py-2 text-xs font-semibold tracking-widest text-gray-700 uppercase transition duration-150 ease-in-out bg-gray-300 border border-transparent rounded-md hover:bg-gray-400">
                            Batal
                            </Link>
                            <button type="submit" :disabled="form.processing" :class="[
                                'inline-flex items-center px-4 py-2 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest transition ease-in-out duration-150',
                                form.processing
                                    ? 'bg-gray-400 cursor-not-allowed'
                                    : 'bg-yellow-600 hover:bg-yellow-700'
                            ]">
                                <i v-if="form.processing" class="mr-2 fas fa-spinner fa-spin"></i>
                                <i v-else class="mr-2 fas fa-save"></i>
                                {{ form.processing ? 'Menyimpan...' : 'Update Pengumuman' }}
                            </button>
                        </div>
                    </form>
                </div>

                <!-- Help Text -->
                <div class="p-4 border border-yellow-200 rounded-md bg-yellow-50">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <i class="text-yellow-400 fas fa-info-circle"></i>
                        </div>
                        <div class="ml-3">
                            <h3 class="text-sm font-medium text-yellow-800">
                                Petunjuk Edit
                            </h3>
                            <div class="mt-2 text-sm text-yellow-700">
                                <ul class="space-y-1 list-disc list-inside">
                                    <li>Semua perubahan akan disimpan setelah klik "Update Pengumuman"</li>
                                    <li>File lampiran yang ada dapat dihapus atau diganti dengan file baru</li>
                                    <li>Mengubah status ke "Aktif" akan mempublikasikan pengumuman</li>
                                    <li>Status "Draft" memungkinkan pengumuman untuk diedit lebih lanjut</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #footer></template>
    </AdminLayout>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { Link, useForm } from '@inertiajs/vue3'
import AdminLayout from '@/Layouts/Container.vue'
import Header from "@/Components/Header.vue";

const props = defineProps({
    pengumuman: Object,
    errors: Object,

})

const form = useForm({
    judul: props.pengumuman.judul,
    konten: props.pengumuman.konten,
    prioritas: props.pengumuman.prioritas,
    status: props.pengumuman.status,
    penerbit: props.pengumuman.penerbit,
    tanggal_publikasi: props.pengumuman.tanggal_publikasi ? new Date(props.pengumuman.tanggal_publikasi).toISOString().split('T')[0] : '',
    tanggal_berakhir: props.pengumuman.tanggal_berakhir ? new Date(props.pengumuman.tanggal_berakhir).toISOString().split('T')[0] : '',
    file_lampiran: null,
    remove_file: false
})

const handleFileUpload = (event) => {
    const file = event.target.files[0]
    form.file_lampiran = file
    form.remove_file = false
}

const removeCurrentFile = () => {
    form.remove_file = true
    form.file_lampiran = null
    // Clear the file input
    const fileInput = document.getElementById('file_lampiran')
    if (fileInput) {
        fileInput.value = ''
    }
}

const getFileName = (filePath) => {
    if (!filePath) return ''
    return filePath.split('/').pop()
}

const getFileUrl = (filePath) => {
    if (!filePath) return ''
    return filePath.startsWith('http') ? filePath : `/storage/${filePath}`
}

const submit = () => {
    form.put(route('pengumuman.update', props.pengumuman.id), {
        onSuccess: () => {
            // Success handled by redirect
        }
    })
}
</script>